import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import classnames from 'classnames';

import { ErrorBoundary } from 'components';
import { useQueryParams } from 'hooks';
import { useAuthState, useAuthDispatch, useFeatureFlagState } from 'context';
import { GroupHero, GroupSideDrawer, GroupSidebar, GroupActivityFeed } from './components';
import { trackInfo, infoMessage } from 'helpers';

import styles from './GroupScreen.module.scss';

export const GroupScreen = () => {
  const history = useHistory();

  const { groupId } = useParams();
  const { groupsFeatureFlag } = useFeatureFlagState();
  const { groupLoginGroupId } = useAuthState();
  const authDispatch = useAuthDispatch();

  const [currentGroup, setCurrentGroup] = React.useState('');
  const showPinned = useQueryParams().get('pinned') === 'true';

  useEffect(() => {
    if (groupsFeatureFlag && groupLoginGroupId) {
      trackInfo(infoMessage.GroupInviteAuthFlowFinished);
      authDispatch({
        type: 'GROUP_LOGIN_UNSET_ID',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (groupId && groupId !== currentGroup) {
      setCurrentGroup(groupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const togglePinned = () => {
    if (showPinned) {
      history.push(`${history.location.pathname}`);
    } else {
      history.push(`${history.location.pathname}?pinned=true`);
    }
  };

  if (currentGroup === groupId) {
    return (
      <ErrorBoundary>
        <GroupSideDrawer togglePinned={togglePinned} showPinned={showPinned} />
        <div className={styles.content}>
          <div className={classnames(styles.contentBin, styles.layoutTetris)}>
            <div className={styles.TetrisColumn}>
              <GroupHero
                className={styles.tetrisHero}
                togglePinned={togglePinned}
                showPinned={showPinned}
              />
              <GroupSidebar className={styles.tetrisSidebar} />
              <div className={classnames(styles.FeedContainer, styles.tetrisMain)}>
                <ErrorBoundary>
                  <GroupActivityFeed showPinned={showPinned} togglePinned={togglePinned} />
                </ErrorBoundary>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }

  return <></>;
};
